module.exports = __webpack_public_path__ + "static/media/logo.62bb7fb2.svg";